import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { featureIds, Indicator } from '~/api/timeseries/timeseries-schema';
import { IndexedTsPoint } from '~/components/snake-chart/snake-chart-utils';
import { indicatorsThresholds } from '~/views/indicators-widget/indicator-constants';

import { SingleWidget } from '../single-widget/SingleWidget';
import * as S from './IndicatorsChart.styles';

export interface IndicatorsChartProps {
  tsData: IndexedTsPoint[];
  onChange: (id: number, tabKey: string) => void;
  activeIndicator: Indicator;
}

export const IndicatorsChart: FC<IndicatorsChartProps> = ({
  tsData,
  onChange,
  activeIndicator,
}) => {
  const { t } = useTranslation('indicators');

  const HeaderElement = (
    <>
      <S.TabLines
        value={activeIndicator}
        onChange={onChange}
        options={featureIds}
      />
      <S.Legend>
        <S.LegendItem>
          <S.Marker />
          <S.Label>{t('widget.legend.tli')}</S.Label>
        </S.LegendItem>
        <S.LegendItem>
          <S.BullishMarker />
          <S.Label>{t('widget.legend.bullishThreshold')}</S.Label>
        </S.LegendItem>
        <S.LegendItem>
          <S.BearishMarker />
          <S.Label>{t('widget.legend.bearishThreshold')}</S.Label>
        </S.LegendItem>
      </S.Legend>
    </>
  );

  const threshold = indicatorsThresholds[activeIndicator];

  return (
    <SingleWidget
      HeaderElement={HeaderElement}
      ContentElement={
        <>
          <S.StyledThresholdChart
            tsData={tsData}
            upperBound={threshold.up}
            lowerBound={threshold.down}
            thresholdVariants={threshold.variants}
            midValue={threshold.mid}
          />
        </>
      }
    />
  );
};
